import * as React from 'react'
import Stack from '@mui/material/Stack'
import Radio from '@mui/material/Radio'

import { useData } from './useData'
import RadioGroup from '@mui/material/RadioGroup'
import Box from '@mui/material/Box'
import FormControlLabel from '@mui/material/FormControlLabel'
import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography/Typography'

import { ManageRecordSection } from '../ManageRecordSection'

export function OppCloseOnScheduleSection() {
  const { value, canClose, onChange, requireACWOppsSchedulingService } =
    useData()

  return (
    <ManageRecordSection>
      <Stack width="100%" direction="column" spacing={1} mb={2}>
        {canClose && requireACWOppsSchedulingService ? (
          <Alert severity="info" sx={{ textAlign: 'left' }}>
            This opportunity will be automatically submitted to the closed/won
            queue upon scheduling service.
          </Alert>
        ) : (
          <>
            <Box px={1.2}>
              <RadioGroup value={value} onChange={onChange}>
                <FormControlLabel
                  value="close"
                  control={<Radio />}
                  disabled={!canClose}
                  label="Close win this sale upon scheduling"
                  data-test-id="close-on-commit-radio-close-win"
                />
                {value === 'close' && (
                  <Alert severity="info" sx={{ textAlign: 'left', ml: 3.2 }}>
                    <Typography variant="body2">
                      This sale will be closed/won upon scheduling and will be
                      submitted to the Closed Won Queue (Closing requirements
                      must be satisfied)
                    </Typography>
                  </Alert>
                )}
                <FormControlLabel
                  value="open"
                  control={<Radio />}
                  label="Keep this record open to allow additional updates"
                  data-test-id="close-on-commit-radio-keep-open"
                />
                {canClose ? (
                  <>
                    {value === 'open' && (
                      <Alert
                        severity="warning"
                        sx={{ textAlign: 'left', ml: 3.2 }}
                      >
                        <Typography variant="body2">
                          This record will remain open upon scheduling service.
                          Complete any remaining closing requirements and
                          Close/Win to submit to the Closed Won Queue
                        </Typography>
                      </Alert>
                    )}
                  </>
                ) : (
                  <Alert severity="warning" sx={{ textAlign: 'left', ml: 3.2 }}>
                    <Typography variant="body2">
                      Closing requirements have not been satisfied to Close Win
                      upon scheduling. You can cancel and complete the closing
                      requirements, or continue to schedule service without
                      closing and sending to the Closed Won Queue
                    </Typography>
                  </Alert>
                )}
              </RadioGroup>
            </Box>
          </>
        )}
      </Stack>
    </ManageRecordSection>
  )
}

OppCloseOnScheduleSection.displayName = 'OppCloseOnScheduleSection'
